import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useAuth } from '../../hooks/useAuth';

const GetStartedPage: React.FC = () => {
    const history = useHistory();
    const isLoggedIn = useAuth();

    useEffect(() => {
        if (isLoggedIn) {
            history.replace('/business');
        } else {
            history.replace('/getstarted');
        }
    }, [isLoggedIn, history]);

    return null;
};

export default GetStartedPage;
